export const initialState = {
  practiceId: '',
  athenaPatientId: '',
  department: null,
};
